import { darken, lighten, PaletteMode } from '@mui/material';
import { grey as MuiGrey } from '@mui/material/colors';

const grey = {
  ...MuiGrey,
  100: '#F6F6F6',
  // 900: '#121212',
};

const primary = '#1A709D';
const primaryLight = '#b0c6ca';
const primaryDark = '#0B132B';
const secondary = '#5b7553';
const secondaryLight = '#849324';
const secondaryDark = '#403233';

const charcoal = '#2E4057';
const background = '#E4DFDA';
export const yellow = '#f49211';

declare module '@mui/material/styles' {
  interface Palette {
    tertiary: Palette['primary'];
    fourtiary: Palette['primary'];
  }

  interface PaletteOptions {
    tertiary?: PaletteOptions['primary'];
    fourtiary?: PaletteOptions['primary'];
  }
}

const palette = (mode: PaletteMode) => {
  return {
    mode,
    grey,
    background: {
      default: background,
    },
    primary: {
      main: primary,
      light: primaryLight,
      dark: primaryDark,
      contrastText: '#fff',
    },
    secondary: {
      main: secondary,
      light: secondaryLight,
      dark: secondaryDark,
      contrastText: '#fff',
    },
    tertiary: {
      main: background,
      light: background,
      contrastText: '#fff',
    },
    fourtiary: {
      main: charcoal,
      light: lighten(charcoal, 0.9),
      dark: darken(charcoal, 0.1),
      contrastText: '#fff',
    },
  };
};

export default palette;
